import { Card, CardProps } from 'baseui/card'; // eslint-disable-next-line baseui/no-deep-imports
import { mergeOverrides } from 'baseui/helpers/overrides';
import { ComponentChildren, h } from 'preact';

const BASE_STYLES = {
    Body: {
        style: {
            height: '100%',
        },
    },
    Root: {
        style: ({ $theme }) => ({
            alignItems: 'stretch',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            transition: '200ms all ease',
            ':focus-within': { boxShadow: $theme.lighting.shadow500 },
            ':hover': { boxShadow: $theme.lighting.shadow500 },
        }),
    },
};

export default function ContentCard({ children, ...passThroughProps }: {
    children: ComponentChildren
} & Partial<Omit<CardProps, 'children'>>) {
    return (
        <Card {...(passThroughProps || {})} overrides={mergeOverrides(BASE_STYLES, passThroughProps?.overrides)}>
            {children}
        </Card>
    );
}
